"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aclTranslationsZh = void 0;
exports.aclTranslationsZh = {
    // ACL Resources
    'acl_resource.company': '公司',
    'acl_resource.user': '用户',
    'acl_resource.user_group': '用户组',
    'acl_resource.settings_general': '通用设置',
    'acl_resource.settings_access': '访问设置',
    'acl_resource.settings_styles': '样式设置',
    'acl_resource.avatar': '头像',
    'acl_resource.ai': '人工智能',
    'acl_resource.knowledge': '知识',
    'acl_resource.project': '项目',
    'acl_resource.onboarding': '入职',
    'acl_resource.reports': '报告',
    // ACL Actions
    'acl_action.read': '读取',
    'acl_action.write': '写入',
    'acl_action.delete': '删除',
};
